// PDF download
const PDF_VALUE = 'shouldPdfRead';
export const pdfReadFeature = {
	enable() {
		localStorage.setItem(PDF_VALUE, 'true');
	},
	disable() {
		localStorage.setItem(PDF_VALUE, 'false');
	},
	get() {
		const val = localStorage.getItem(PDF_VALUE);
		return JSON.parse(val);
	},
};
